module.exports = __webpack_public_path__ + "img/mouse_spiderman.c2acc962.png";